import { Component, TemplateRef, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AuthService } from "app/base-module/base-service/auth.service";
import { Usuario } from "app/usuarios/models/user.model";
import { ActionDialog, BaseComponent } from "../../base-module/base-component/base.component";
import { CadastroCarteiraConsorcioComponent } from "../cadastro-carteira-consorcio/cadastro-carteira-consorcio.component";
import { ClienteCarteiraConsorcioService } from "../services/cliente-carteira-consorcio.service";

@Component({
    selector: "app-lista-cliente-carteira-consorcio",
    templateUrl: "./lista-cliente-carteira-consorcio.component.html",
    styleUrls: ["./lista-cliente-carteira-consorcio.component.scss"],
})
export class ListaClienteCarteiraConsorcioComponent extends BaseComponent {
    user: Usuario | null = null;

    @ViewChild("addButtonTmpl", { static: false }) addButtonTmpl!: TemplateRef<unknown>;
    @ViewChild(ListaClienteCarteiraConsorcioComponent, { static: false })
    table!: ListaClienteCarteiraConsorcioComponent;

    constructor(
        public _service: ClienteCarteiraConsorcioService,
        public dialog: MatDialog,
        override snackBar: MatSnackBar,
        private _authService: AuthService
    ) {
        super(dialog, snackBar);

        this.getAll();
        const strUser = this._authService.getUser();
        this.user = JSON.parse(strUser ? strUser : "{}");
    }

    /**
     * Evento da paginação
     * @param {PageEvent} event
     */
    pageEvent(event: PageEvent): void {
        this.params.page = event.pageIndex + 1;
        this.params.per_page = event.pageSize;

        this.getAll();
    }

    /**
     * Consulta lista de Carteira do Consórcio
     * @returns {void}
     */
    getAll(): void {
        this.loadingIndicator = true;
        this._service.getAll(this.params).subscribe({
            next: (data) => {
                this.length = data.meta.total;
                this.rows = data.data;
                this.temp = [...this.rows];
            },
            error: (error) => {
                this.loadingIndicator = false;
                this.showError(`Erro ao buscar carteiras: ${error.error?.message || error.message}`);
            },
            complete: () => {
                this.loadingIndicator = false;
            },
        });
    }

    /**
     * Exclui Carteira do Consórcio
     * @param {number} id - ID da carteira a ser excluída
     * @returns {void}
     */
    delete(id: number): void {
        this.dialog.open(ActionDialog, {
            width: "250px",
            disableClose: true,
            data: {
                title: "Excluir Carteira do Consórcio",
                text: "Deseja realmente excluir este item?",
                callback: () => {
                    this.dialog.closeAll();

                    this.loadingIndicator = true;
                    this._service.delete(id).subscribe({
                        next: (data) => {
                            this.loadingIndicator = false;
                            this.showSuccess(data.message);
                            this.getAll();
                        },
                        error: (error) => {
                            this.loadingIndicator = false;
                            this.showError(`Erro ao excluir carteira: ${error.error?.message || error.message}`);
                        },
                        complete: () => {
                            // Loading será fechado em next ou error
                        },
                    });
                },
            },
        });
    }

    /**
     * Modal de cadastro
     * @returns {void}
     */
    openCadastro(): void {
        const dialogRef = this.dialog.open(CadastroCarteiraConsorcioComponent, {
            width: "400px",
            height: "80%",
        });

        dialogRef.afterClosed().subscribe((result: unknown) => {
            if (result !== undefined && result !== null && result !== "cancel") {
                this.showSuccess("Carteira do Consórcio cadastrado com sucesso!");
                this.getAll();
            }
        });
    }

    /**
     * Modal de edição
     * @param {number} id - ID da carteira a ser editada
     * @returns {void}
     */
    openAlterar(id: number): void {
        const dialogRef = this.dialog.open(CadastroCarteiraConsorcioComponent, {
            width: "400px",
            height: "80%",
            data: {
                id: id,
            },
        });

        dialogRef.afterClosed().subscribe((result: unknown) => {
            if (result !== undefined && result !== null && result !== "cancel") {
                this.showSuccess("Carteira do Consórcio atualizado com sucesso!");
                this.getAll();
            }
        });
    }
}
